import { HttpParams } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { ProjectsFilter } from '../interfaces/projects-filter.interface';
import { ProjectsConfig, ProjectsConfigService } from '../projects.config';

@Injectable({
    providedIn: 'root',
})
export class RoutesUtil {
    private readonly route = '/';
    private readonly apiGatewayUrl: string;
    private readonly projects = 'projects';
    private readonly personProjectsPath = 'person-projects';

    constructor(@Inject(ProjectsConfigService) projectsConfig: ProjectsConfig) {
        this.apiGatewayUrl = projectsConfig.apiGateway;
    }

    public getProjectsMetaInformation(): string {
        return `${this.apiGatewayUrl}${this.projects}`;
    }

    public updateProjectsMetaInformation(projectId: string): string {
        return `${this.apiGatewayUrl}${this.projects}/${projectId}`;
    }

    bulkUpdateProjectsMetaInformation(): string {
        return `${this.apiGatewayUrl}${this.projects}/bulk-update-status`;
    }

    public bulkDeleteProjects(): string {
        return `${this.apiGatewayUrl}${this.projects}/bulk-delete`;
    }

    public deleteProjectsMetaInformation(projectId: string): string {
        return `${this.apiGatewayUrl}${this.projects}/${projectId}`;
    }

    public fetchProjectIdByAnnualReportMetaInfoId(annualReportMetaInformationId: string): string {
        return `${this.apiGatewayUrl}${this.projects}/annual-report-meta-information/${annualReportMetaInformationId}`;
    }

    public fetchProjectInformationByProjectId(projectId: string): string {
        return `${this.apiGatewayUrl}${this.projects}/${projectId}`;
    }

    // REV-22155 — person projects
    public personProjects(): string {
        return `${this.apiGatewayUrl}${this.personProjectsPath}`;
    }

    public personProject(projectId: string, suffix = ''): string {
        return `${this.apiGatewayUrl}${this.personProjectsPath}/${projectId}${suffix}`;
    }

    public buildHttpParams(filter?: ProjectsFilter | object): HttpParams {
        let params = new HttpParams();

        if (!filter) {
            return params;
        }

        Object.entries(filter).forEach(([key, value]) => {
            if (value === undefined || value === null) return;

            if (Array.isArray(value)) {
                // Filter out null/undefined items from the array
                const validItems = value.filter((item) => item !== undefined && item !== null);
                validItems.forEach((item) => {
                    params = params.append(key, item.toString());
                });
                // workaround: repeating the value if filter property has only 1 item to be sent as an array to the backend
                if (validItems.length === 1) {
                    params = params.append(key, validItems[0].toString());
                }
            } else {
                params = params.append(key, value.toString());
            }
        });

        return params;
    }
}
